export default "__VITE_ASSET__Be5$_EGL__"